/* ingarden Science Page - Animations & Interactions */
(function(){
'use strict';

/* -- Scroll Reveal -- */
var ro = new IntersectionObserver(function(entries){
  entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('ig-visible');});
},{threshold:.08,rootMargin:'0px 0px -50px 0px'});
document.querySelectorAll('.ig-reveal').forEach(function(el){ro.observe(el);});

/* -- Study Accordion -- */
document.querySelectorAll('.ig-study').forEach(function(el){
  el.querySelector('.ig-study-hd').addEventListener('click',function(){
    el.classList.toggle('open');
  });
});

/* -- Tab Switching -- */
document.querySelectorAll('.ig-tab').forEach(function(btn){
  btn.addEventListener('click',function(){
    var target=btn.dataset.tab;
    document.querySelectorAll('.ig-tab').forEach(function(b){b.classList.remove('active');});
    document.querySelectorAll('.ig-tab-panel').forEach(function(p){p.classList.remove('active');p.style.display='none';});
    btn.classList.add('active');
    var panel=document.getElementById(target);
    if(panel){panel.classList.add('active');panel.style.display='block';}
  });
});
// init first tab
(function(){
  var panels=document.querySelectorAll('.ig-tab-panel');
  panels.forEach(function(p){p.style.display='none';});
  var first=document.querySelector('.ig-tab-panel');
  if(first){first.style.display='block';first.classList.add('active');}
})();

/* -- Sulforaphane Chart (statisch, sofort sichtbar, keine verspielte Animation) -- */
(function(){
  var barM=document.getElementById('ig-bar-micro');
  var barR=document.getElementById('ig-bar-ripe');
  var valM=document.getElementById('ig-val-micro');
  var valR=document.getElementById('ig-val-ripe');
  var callN=document.getElementById('ig-callout-num');
  var counterEl=document.getElementById('ig-sulfo-big-num');
  if(barM)barM.setAttribute('style','display:block!important;height:100%;width:100%;background:linear-gradient(90deg,#6030CC,#8048ED,#A66BFF);transform:scaleX(1);transform-origin:left center;border-radius:8px;');
  if(barR)barR.setAttribute('style','display:block!important;height:100%;width:100%;background:linear-gradient(90deg,#595959,#DBC6AD);transform:scaleX(0.01);transform-origin:left center;border-radius:8px;');
  if(valM)valM.textContent='100x';
  if(valR)valR.textContent='1x';
  if(callN)callN.textContent='100';
  if(counterEl)counterEl.textContent='100';
})();

/* -- Intracellular Animations -- */
var intraDone=false;
var intraObs=new IntersectionObserver(function(entries){
  entries.forEach(function(e){if(e.isIntersecting&&!intraDone){intraDone=true;initIntra();}});
},{threshold:.3});
var intraEl=document.querySelector('.ig-anim-grid');
if(intraEl)intraObs.observe(intraEl);

function initIntra(){drawGoodCell();drawBadCell();}

function drawGoodCell(){
  var canvas=document.getElementById('ig-canvas-good');
  if(!canvas)return;
  var ctx=canvas.getContext('2d');
  var W=canvas.width=200,H=canvas.height=200;
  var cx=W/2,cy=H/2,R=58;
  var nutrients=[];
  for(var i=0;i<12;i++){
    var a=(i/12)*Math.PI*2;
    var sr=R+48+Math.random()*18;
    nutrients.push({
      x:cx+Math.cos(a)*sr,y:cy+Math.sin(a)*sr,
      tx:cx+(Math.random()-.5)*50,ty:cy+(Math.random()-.5)*50,
      r:4+Math.random()*2.5,progress:Math.random(),speed:.3+Math.random()*.4,
      color:Math.random()>.5?'#8048ED':'#C2FC82'
    });
  }
  var t=0;
  (function frame(){
    ctx.clearRect(0,0,W,H);t+=.018;
    var pulse=1+Math.sin(t*1.5)*.015;
    var g=ctx.createRadialGradient(cx,cy,R-10,cx,cy,R+12);
    g.addColorStop(0,'rgba(128,72,237,.15)');g.addColorStop(1,'transparent');
    ctx.beginPath();ctx.arc(cx,cy,R+10,0,Math.PI*2);ctx.fillStyle=g;ctx.fill();
    ctx.beginPath();ctx.arc(cx,cy,R*pulse,0,Math.PI*2);ctx.strokeStyle='#8048ED';ctx.lineWidth=2.5;ctx.stroke();
    var gi=ctx.createRadialGradient(cx,cy,0,cx,cy,R);
    gi.addColorStop(0,'rgba(128,72,237,.1)');gi.addColorStop(1,'rgba(128,72,237,.02)');
    ctx.beginPath();ctx.arc(cx,cy,R,0,Math.PI*2);ctx.fillStyle=gi;ctx.fill();
    ctx.beginPath();ctx.arc(cx,cy,18,0,Math.PI*2);ctx.fillStyle='rgba(128,72,237,.2)';ctx.fill();
    ctx.strokeStyle='rgba(128,72,237,.5)';ctx.lineWidth=1.5;ctx.stroke();
    nutrients.forEach(function(n){
      n.progress=(n.progress+n.speed*.007)%1;
      var e=n.progress<.5?2*n.progress*n.progress:1-Math.pow(-2*n.progress+2,2)/2;
      var x=n.x+(n.tx-n.x)*e,y=n.y+(n.ty-n.y)*e;
      var alpha=n.progress<.2?n.progress/.2:n.progress>.85?1-(n.progress-.85)/.15:1;
      ctx.beginPath();ctx.arc(x,y,n.r,0,Math.PI*2);ctx.fillStyle=n.color;ctx.globalAlpha=alpha;ctx.fill();
      if(n.progress>.05&&n.progress<.7){
        ctx.beginPath();ctx.moveTo(n.x+(n.tx-n.x)*e*.85,n.y+(n.ty-n.y)*e*.85);ctx.lineTo(x,y);
        ctx.strokeStyle=n.color;ctx.lineWidth=1.5;ctx.globalAlpha=alpha*.25;ctx.stroke();
      }
      ctx.globalAlpha=1;
    });
    ctx.fillStyle='rgba(194,252,130,.9)';ctx.font='bold 14px sans-serif';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('v',cx,cy);
    requestAnimationFrame(frame);
  })();
}

function drawBadCell(){
  var canvas=document.getElementById('ig-canvas-bad');
  if(!canvas)return;
  var ctx=canvas.getContext('2d');
  var W=canvas.width=200,H=canvas.height=200;
  var cx=W/2,cy=H/2,R=58;
  var particles=[];
  for(var i=0;i<12;i++){
    var a=Math.random()*Math.PI*2;
    var d=R+28+Math.random()*22;
    particles.push({orbitAngle:a,orbitR:d,orbitSpeed:(Math.random()-.5)*.012,r:4+Math.random()*2.5,bounceT:Math.random()*Math.PI*2});
  }
  (function frame(){
    ctx.clearRect(0,0,W,H);
    ctx.beginPath();ctx.arc(cx,cy,R,0,Math.PI*2);ctx.strokeStyle='#DBC6AD';ctx.lineWidth=2.5;ctx.setLineDash([5,4]);ctx.stroke();ctx.setLineDash([]);
    var gi=ctx.createRadialGradient(cx,cy,0,cx,cy,R);gi.addColorStop(0,'rgba(219,198,173,.1)');gi.addColorStop(1,'rgba(219,198,173,.02)');
    ctx.beginPath();ctx.arc(cx,cy,R,0,Math.PI*2);ctx.fillStyle=gi;ctx.fill();
    ctx.beginPath();ctx.arc(cx,cy,18,0,Math.PI*2);ctx.fillStyle='rgba(219,198,173,.15)';ctx.fill();ctx.strokeStyle='rgba(219,198,173,.4)';ctx.lineWidth=1.5;ctx.stroke();
    particles.forEach(function(p){
      p.orbitAngle+=p.orbitSpeed;p.bounceT+=.04;
      var bounce=Math.abs(Math.sin(p.bounceT))*7;
      var px=cx+Math.cos(p.orbitAngle)*p.orbitR;
      var py=cy+Math.sin(p.orbitAngle)*p.orbitR;
      var x=px+Math.cos(p.orbitAngle)*bounce;
      var y=py+Math.sin(p.orbitAngle)*bounce;
      ctx.beginPath();ctx.arc(x,y,p.r,0,Math.PI*2);ctx.fillStyle='#DBC6AD';ctx.globalAlpha=.7;ctx.fill();
      if(bounce>3){ctx.beginPath();ctx.moveTo(px,py);ctx.lineTo(x,y);ctx.strokeStyle='#E8DBCA';ctx.lineWidth=1.5;ctx.globalAlpha=.35;ctx.stroke();}
      ctx.globalAlpha=1;
    });
    ctx.fillStyle='rgba(219,198,173,.9)';ctx.font='bold 15px sans-serif';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('x',cx,cy);
    requestAnimationFrame(frame);
  })();
}

})();
